import React from "react";
import NewHero from "../../components/newhero/NewHero";
import Impact  from "../../components/Impact/Impact";
import WhatIsgdg from "../../components/whatIsgdg/WhatIsgdg";
import ThingsYouDontWantToMissMain from "../../components/thingsYouDontWantToMissSection/ThingsYouDontWantToMissMain";
import Slider from "../../components/slider/Slider";
import { Sponsors } from "../../components/sponsors/Sponsors";

const Home = () => {
  //  const [showPage, setShowHero] = useState(false);

  //  useEffect(() => {
  //    setTimeout(() => {
  //     setShowHero(true)
  //    }, 5000);
  //  }, [showPage]);

  return (
    <div className={"layout-content"}>
      {" "}
      <NewHero></NewHero>
      <WhatIsgdg></WhatIsgdg>
      <Slider></Slider>
      <Impact></Impact>
      <ThingsYouDontWantToMissMain></ThingsYouDontWantToMissMain>
      <Sponsors></Sponsors>
    </div>
  );
};

export default Home;
